/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.12.1.0 (NJsonSchema v10.4.6.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming
import { CommonServices } from "@/services/CommonServices";
import { baseUrl } from '@/config';
class _LocalizationClient {
    getAll(showSpinner = true) {
        return CommonServices.defaultGet(baseUrl + 'api/Localization/GetAll', {}, showSpinner);
    }
    getEnabledLanguages(showSpinner = true) {
        return CommonServices.defaultGet(baseUrl + 'api/Localization/GetEnabledLanguages', {}, showSpinner);
    }
    deleteByKey(identifier, showSpinner = true) {
        return CommonServices.defaultGet(baseUrl + 'api/Localization/DeleteByKey', { identifier }, showSpinner);
    }
    save(item, showSpinner = true) {
        return CommonServices.defaultPost(baseUrl + 'api/Localization/Save', item, {}, showSpinner);
    }
}
export let LocalizationClient = new _LocalizationClient();
class _AppConfigClient {
    getConfig(showSpinner = true) {
        return CommonServices.defaultGet(baseUrl + 'api/AppConfig/GetConfig', {}, showSpinner);
    }
    saveConfig(config, showSpinner = true) {
        return CommonServices.defaultPost(baseUrl + 'api/AppConfig/SaveConfig', config, {}, showSpinner);
    }
}
export let AppConfigClient = new _AppConfigClient();
class _CustomerClusterClient {
    getAll(showSpinner = true) {
        return CommonServices.defaultGet(baseUrl + 'api/CustomerCluster/GetAll', {}, showSpinner);
    }
    getById(clusterIdentifier, showSpinner = true) {
        return CommonServices.defaultGet(baseUrl + 'api/CustomerCluster/GetById', { clusterIdentifier }, showSpinner);
    }
    getAllAsNameIdentifier(showSpinner = true) {
        return CommonServices.defaultGet(baseUrl + 'api/CustomerCluster/GetAllAsNameIdentifier', {}, showSpinner);
    }
    save(item, showSpinner = true) {
        return CommonServices.defaultPost(baseUrl + 'api/CustomerCluster/Save', item, {}, showSpinner);
    }
}
export let CustomerClusterClient = new _CustomerClusterClient();
class _CustomerClient {
    getAll(officeIdentifier, freezed, showSpinner = true) {
        return CommonServices.defaultGet(baseUrl + 'api/Customer/GetAll', { officeIdentifier, freezed }, showSpinner);
    }
    exportExcel(showSpinner = true) {
        return CommonServices.defaultGet(baseUrl + 'api/Customer/ExportExcel', {}, showSpinner);
    }
    getOnOffice(officeIdentifier, showSpinner = true) {
        return CommonServices.defaultGet(baseUrl + 'api/Customer/GetOnOffice', { officeIdentifier }, showSpinner);
    }
    getChildrenOfCustomer(customerIdentifier, showSpinner = true) {
        return CommonServices.defaultGet(baseUrl + 'api/Customer/GetChildrenOfCustomer', { customerIdentifier }, showSpinner);
    }
    getFamilyAsNameIdentifier(customerIdentifier, showSpinner = true) {
        return CommonServices.defaultGet(baseUrl + 'api/Customer/GetFamilyAsNameIdentifier', { customerIdentifier }, showSpinner);
    }
    getTransactionsOfCustomer(customerIdentifier, showSpinner = true) {
        return CommonServices.defaultGet(baseUrl + 'api/Customer/GetTransactionsOfCustomer', { customerIdentifier }, showSpinner);
    }
    getMailMemoOfCustomer(customerMail, showSpinner = true) {
        return CommonServices.defaultGet(baseUrl + 'api/Customer/GetMailMemoOfCustomer', { customerMail }, showSpinner);
    }
    getById(customerIdentifier, showSpinner = true) {
        return CommonServices.defaultGet(baseUrl + 'api/Customer/GetById', { customerIdentifier }, showSpinner);
    }
    getForTrello(vm, showSpinner = true) {
        return CommonServices.defaultPost(baseUrl + 'api/Customer/GetForTrello', vm, {}, showSpinner);
    }
    exportByState(state, showSpinner = true) {
        return CommonServices.defaultGet(baseUrl + 'api/Customer/ExportByState', { state }, showSpinner);
    }
    getProvenienzaStat(showSpinner = true) {
        return CommonServices.defaultGet(baseUrl + 'api/Customer/GetProvenienzaStat', {}, showSpinner);
    }
    getStellineStat(showSpinner = true) {
        return CommonServices.defaultGet(baseUrl + 'api/Customer/GetStellineStat', {}, showSpinner);
    }
    getCreditiStat(showSpinner = true) {
        return CommonServices.defaultGet(baseUrl + 'api/Customer/GetCreditiStat', {}, showSpinner);
    }
    getCreditiFreezatiStat(showSpinner = true) {
        return CommonServices.defaultGet(baseUrl + 'api/Customer/getCreditiFreezatiStat', {}, showSpinner);
    }
    setCustomerState(identifier, newState, showSpinner = true) {
        return CommonServices.defaultGet(baseUrl + 'api/Customer/SetCustomerState', { identifier, newState }, showSpinner);
    }
    getStoricoCliente(identifier, showSpinner = true) {
        return CommonServices.defaultGet(baseUrl + 'api/Customer/GetStoricoCliente', { identifier }, showSpinner);
    }
    getNewClientiStat(mese, anno, showSpinner = true) {
        return CommonServices.defaultGet(baseUrl + 'api/Customer/GetNewClientiStat', { mese, anno }, showSpinner);
    }
    getChildrenOf(parentIdentifier, showSpinner = true) {
        return CommonServices.defaultGet(baseUrl + 'api/Customer/GetChildrenOf', { parentIdentifier }, showSpinner);
    }
    getAsCustomerServiceTable(vm, showSpinner = true) {
        return CommonServices.defaultPost(baseUrl + 'api/Customer/GetAsCustomerServiceTable', vm, {}, showSpinner);
    }
    updateLastContact(customerIdentifier, value, showSpinner = true) {
        return CommonServices.defaultGet(baseUrl + 'api/Customer/UpdateLastContact', { customerIdentifier, value }, showSpinner);
    }
    removeParent(customerIdentifier, showSpinner = true) {
        return CommonServices.defaultGet(baseUrl + 'api/Customer/RemoveParent', { customerIdentifier }, showSpinner);
    }
    createCustomerChild(vm, showSpinner = true) {
        return CommonServices.defaultPost(baseUrl + 'api/Customer/CreateCustomerChild', vm, {}, showSpinner);
    }
    save(item, showSpinner = true) {
        return CommonServices.defaultPost(baseUrl + 'api/Customer/Save', item, {}, showSpinner);
    }
    setPassword(vm, showSpinner = true) {
        return CommonServices.defaultPost(baseUrl + 'api/Customer/SetPassword', vm, {}, showSpinner);
    }
    delete(customerIdentifier, showSpinner = true) {
        return CommonServices.defaultGet(baseUrl + 'api/Customer/Delete', { customerIdentifier }, showSpinner);
    }
    getCustomerMarkers(showSpinner = true) {
        return CommonServices.defaultGet(baseUrl + 'api/Customer/GetCustomerMarkers', {}, showSpinner);
    }
    addCredit(vm, showSpinner = true) {
        return CommonServices.defaultPost(baseUrl + 'api/Customer/AddCredit', vm, {}, showSpinner);
    }
    deleteAttachment(vm, showSpinner = true) {
        return CommonServices.defaultPost(baseUrl + 'api/Customer/DeleteAttachment', vm, {}, showSpinner);
    }
}
export let CustomerClient = new _CustomerClient();
class _LoginClient {
    registerAsCustomer(vm, showSpinner = true) {
        return CommonServices.defaultPost(baseUrl + 'api/Login/RegisterAsCustomer', vm, {}, showSpinner);
    }
    login(vm, showSpinner = true) {
        return CommonServices.defaultPost(baseUrl + 'api/Login/Login', vm, {}, showSpinner);
    }
    askPasswordReset(email, showSpinner = true) {
        return CommonServices.defaultGet(baseUrl + 'api/Login/AskPasswordReset', { email }, showSpinner);
    }
    passwordReset(vm, showSpinner = true) {
        return CommonServices.defaultPost(baseUrl + 'api/Login/PasswordReset', vm, {}, showSpinner);
    }
}
export let LoginClient = new _LoginClient();
class _MailSentClient {
    getAll(showSpinner = true) {
        return CommonServices.defaultGet(baseUrl + 'api/MailSent/GetAll', {}, showSpinner);
    }
    getById(identifier, showSpinner = true) {
        return CommonServices.defaultGet(baseUrl + 'api/MailSent/GetById', { identifier }, showSpinner);
    }
}
export let MailSentClient = new _MailSentClient();
class _MailTemplateClient {
    getAll(showSpinner = true) {
        return CommonServices.defaultGet(baseUrl + 'api/MailTemplate/GetAll', {}, showSpinner);
    }
    getById(identifier, showSpinner = true) {
        return CommonServices.defaultGet(baseUrl + 'api/MailTemplate/GetById', { identifier }, showSpinner);
    }
    getByEventName(eventName, showSpinner = true) {
        return CommonServices.defaultGet(baseUrl + 'api/MailTemplate/GetByEventName', { eventName }, showSpinner);
    }
    save(item, showSpinner = true) {
        return CommonServices.defaultPost(baseUrl + 'api/MailTemplate/Save', item, {}, showSpinner);
    }
    delete(identifier, showSpinner = true) {
        return CommonServices.defaultGet(baseUrl + 'api/MailTemplate/Delete', { identifier }, showSpinner);
    }
    sendMail(vm, showSpinner = true) {
        return CommonServices.defaultPost(baseUrl + 'api/MailTemplate/SendMail', vm, {}, showSpinner);
    }
    sendPersonalMail(vm, showSpinner = true) {
        return CommonServices.defaultPost(baseUrl + 'api/MailTemplate/SendPersonalMail', vm, {}, showSpinner);
    }
    sendSystemMail(vm, showSpinner = true) {
        return CommonServices.defaultPost(baseUrl + 'api/MailTemplate/SendSystemMail', vm, {}, showSpinner);
    }
}
export let MailTemplateClient = new _MailTemplateClient();
class _OnOfficeClient {
    sendAttachmentToOnOnffice(taskIdentifier, showSpinner = true) {
        return CommonServices.defaultGet(baseUrl + 'api/OnOffice/SendAttachmentToOnOnffice', { taskIdentifier }, showSpinner);
    }
}
export let OnOfficeClient = new _OnOfficeClient();
class _PortafoglioClient {
    getByCustomerIdentifier(customerIdentifier, showSpinner = true) {
        return CommonServices.defaultGet(baseUrl + 'api/Portafoglio/GetByCustomerIdentifier', { customerIdentifier }, showSpinner);
    }
    ricalcolaPortafoglio(customerIdentifier, showSpinner = true) {
        return CommonServices.defaultGet(baseUrl + 'api/Portafoglio/RicalcolaPortafoglio', { customerIdentifier }, showSpinner);
    }
}
export let PortafoglioClient = new _PortafoglioClient();
class _ProductClient {
    getAll(showSpinner = true) {
        return CommonServices.defaultGet(baseUrl + 'api/Product/GetAll', {}, showSpinner);
    }
    getByCustomerIdentifier(customerIdentifier, showSpinner = true) {
        return CommonServices.defaultGet(baseUrl + 'api/Product/GetByCustomerIdentifier', { customerIdentifier }, showSpinner);
    }
    getForGestim(showSpinner = true) {
        return CommonServices.defaultGet(baseUrl + 'api/Product/GetForGestim', {}, showSpinner);
    }
    getForGestimByCustomerIdentifier(customerIdentifier, showSpinner = true) {
        return CommonServices.defaultGet(baseUrl + 'api/Product/GetForGestimByCustomerIdentifier', { customerIdentifier }, showSpinner);
    }
    getById(productIdentifier, showSpinner = true) {
        return CommonServices.defaultGet(baseUrl + 'api/Product/GetById', { productIdentifier }, showSpinner);
    }
    delete(productIdentifier, showSpinner = true) {
        return CommonServices.defaultGet(baseUrl + 'api/Product/Delete', { productIdentifier }, showSpinner);
    }
    getProductsAsVmList(customerIdentifier, showSpinner = true) {
        return CommonServices.defaultGet(baseUrl + 'api/Product/GetProductsAsVmList', { customerIdentifier }, showSpinner);
    }
    save(prod, showSpinner = true) {
        return CommonServices.defaultPost(baseUrl + 'api/Product/Save', prod, {}, showSpinner);
    }
    postOrderIntent(vm, showSpinner = true) {
        return CommonServices.defaultPost(baseUrl + 'api/Product/PostOrderIntent', vm, {}, showSpinner);
    }
    completePostOrder(vm, showSpinner = true) {
        return CommonServices.defaultPost(baseUrl + 'api/Product/CompletePostOrder', vm, {}, showSpinner);
    }
}
export let ProductClient = new _ProductClient();
class _ReferralClient {
    getAll(showSpinner = true) {
        return CommonServices.defaultGet(baseUrl + 'api/Referral/GetAll', {}, showSpinner);
    }
    getById(identifier, showSpinner = true) {
        return CommonServices.defaultGet(baseUrl + 'api/Referral/GetById', { identifier }, showSpinner);
    }
    getByReferrerIdentifier(referrerIdentifier, showSpinner = true) {
        return CommonServices.defaultGet(baseUrl + 'api/Referral/GetByReferrerIdentifier', { referrerIdentifier }, showSpinner);
    }
    delete(referrerIdentifier, showSpinner = true) {
        return CommonServices.defaultGet(baseUrl + 'api/Referral/Delete', { referrerIdentifier }, showSpinner);
    }
    save(item, showSpinner = true) {
        return CommonServices.defaultPost(baseUrl + 'api/Referral/Save', item, {}, showSpinner);
    }
}
export let ReferralClient = new _ReferralClient();
class _RegistroAccessiClient {
    getAll(showSpinner = true) {
        return CommonServices.defaultGet(baseUrl + 'api/RegistroAccessi/GetAll', {}, showSpinner);
    }
}
export let RegistroAccessiClient = new _RegistroAccessiClient();
class _RichiestaPagamentoUserClient {
    getAll(showSpinner = true) {
        return CommonServices.defaultGet(baseUrl + 'api/RichiestaPagamentoUser/GetAll', {}, showSpinner);
    }
    getById(identifier, showSpinner = true) {
        return CommonServices.defaultGet(baseUrl + 'api/RichiestaPagamentoUser/GetById', { identifier }, showSpinner);
    }
    removeRichiesta(identifier, showSpinner = true) {
        return CommonServices.defaultGet(baseUrl + 'api/RichiestaPagamentoUser/RemoveRichiesta', { identifier }, showSpinner);
    }
    getRichiestePagamentoPendingByUser(userIdentifier, showSpinner = true) {
        return CommonServices.defaultGet(baseUrl + 'api/RichiestaPagamentoUser/GetRichiestePagamentoPendingByUser', { userIdentifier }, showSpinner);
    }
    inviaRichiesta(identifier, showSpinner = true) {
        return CommonServices.defaultGet(baseUrl + 'api/RichiestaPagamentoUser/InviaRichiesta', { identifier }, showSpinner);
    }
    setGestita(identifier, isGestita, showSpinner = true) {
        return CommonServices.defaultGet(baseUrl + 'api/RichiestaPagamentoUser/SetGestita', { identifier, isGestita }, showSpinner);
    }
    getByUser(userIdentifier, showSpinner = true) {
        return CommonServices.defaultGet(baseUrl + 'api/RichiestaPagamentoUser/GetByUser', { userIdentifier }, showSpinner);
    }
    getTaskPagati(userIdentifier, showSpinner = true) {
        return CommonServices.defaultGet(baseUrl + 'api/RichiestaPagamentoUser/GetTaskPagati', { userIdentifier }, showSpinner);
    }
    generaPagamentoCompensi(vm, showSpinner = true) {
        return CommonServices.defaultPost(baseUrl + 'api/RichiestaPagamentoUser/GeneraPagamentoCompensi', vm, {}, showSpinner);
    }
    generaRitenutaAcconto(richiestaPagamentoIdentifier, showSpinner = true) {
        return CommonServices.defaultGet(baseUrl + 'api/RichiestaPagamentoUser/GeneraRitenutaAcconto', { richiestaPagamentoIdentifier }, showSpinner);
    }
    generaReportTask(richiestaPagamentoIdentifier, showSpinner = true) {
        return CommonServices.defaultGet(baseUrl + 'api/RichiestaPagamentoUser/GeneraReportTask', { richiestaPagamentoIdentifier }, showSpinner);
    }
}
export let RichiestaPagamentoUserClient = new _RichiestaPagamentoUserClient();
class _RiepilogoGiornalieroClient {
    getInDates(startDate, endDate, showSpinner = true) {
        return CommonServices.defaultGet(baseUrl + 'api/RiepilogoGiornaliero/GetInDates', { startDate, endDate }, showSpinner);
    }
    getById(identifier, showSpinner = true) {
        return CommonServices.defaultGet(baseUrl + 'api/RiepilogoGiornaliero/GetById', { identifier }, showSpinner);
    }
    save(item, showSpinner = true) {
        return CommonServices.defaultPost(baseUrl + 'api/RiepilogoGiornaliero/Save', item, {}, showSpinner);
    }
    getRiepilogoMensile(mese, anno, showSpinner = true) {
        return CommonServices.defaultGet(baseUrl + 'api/RiepilogoGiornaliero/GetRiepilogoMensile', { mese, anno }, showSpinner);
    }
    calculateRiepilogoOfDate(date, showSpinner = true) {
        return CommonServices.defaultGet(baseUrl + 'api/RiepilogoGiornaliero/CalculateRiepilogoOfDate', { date }, showSpinner);
    }
}
export let RiepilogoGiornalieroClient = new _RiepilogoGiornalieroClient();
class _ShopOfferClient {
    getAll(showSpinner = true) {
        return CommonServices.defaultGet(baseUrl + 'api/ShopOffer/GetAll', {}, showSpinner);
    }
    getByCustomerIdentifier(customerIdentifier, showSpinner = true) {
        return CommonServices.defaultGet(baseUrl + 'api/ShopOffer/GetByCustomerIdentifier', { customerIdentifier }, showSpinner);
    }
    getById(identifier, showSpinner = true) {
        return CommonServices.defaultGet(baseUrl + 'api/ShopOffer/GetById', { identifier }, showSpinner);
    }
    toggleDisabledById(identifier, showSpinner = true) {
        return CommonServices.defaultGet(baseUrl + 'api/ShopOffer/ToggleDisabledById', { identifier }, showSpinner);
    }
    save(item, showSpinner = true) {
        return CommonServices.defaultPost(baseUrl + 'api/ShopOffer/Save', item, {}, showSpinner);
    }
    createIntent(vm, showSpinner = true) {
        return CommonServices.defaultPost(baseUrl + 'api/ShopOffer/CreateIntent', vm, {}, showSpinner);
    }
    completeBuy(vm, showSpinner = true) {
        return CommonServices.defaultPost(baseUrl + 'api/ShopOffer/CompleteBuy', vm, {}, showSpinner);
    }
}
export let ShopOfferClient = new _ShopOfferClient();
class _ShopOfferGestimClient {
    getAll(showSpinner = true) {
        return CommonServices.defaultGet(baseUrl + 'api/ShopOfferGestim/GetAll', {}, showSpinner);
    }
    getById(identifier, showSpinner = true) {
        return CommonServices.defaultGet(baseUrl + 'api/ShopOfferGestim/GetById', { identifier }, showSpinner);
    }
    save(item, showSpinner = true) {
        return CommonServices.defaultPost(baseUrl + 'api/ShopOfferGestim/Save', item, {}, showSpinner);
    }
    createIntent(vm, showSpinner = true) {
        return CommonServices.defaultPost(baseUrl + 'api/ShopOfferGestim/CreateIntent', vm, {}, showSpinner);
    }
    completeBuy(vm, showSpinner = true) {
        return CommonServices.defaultPost(baseUrl + 'api/ShopOfferGestim/CompleteBuy', vm, {}, showSpinner);
    }
}
export let ShopOfferGestimClient = new _ShopOfferGestimClient();
class _StripeClient {
    listCustomerCards(customerIdentifier, showSpinner = true) {
        return CommonServices.defaultGet(baseUrl + 'api/Stripe/ListCustomerCards', { customerIdentifier }, showSpinner);
    }
    addCardToCustomer(vm, showSpinner = true) {
        return CommonServices.defaultPost(baseUrl + 'api/Stripe/AddCardToCustomer', vm, {}, showSpinner);
    }
    removeCardFromCustomer(vm, showSpinner = true) {
        return CommonServices.defaultPost(baseUrl + 'api/Stripe/RemoveCardFromCustomer', vm, {}, showSpinner);
    }
}
export let StripeClient = new _StripeClient();
class _TaskClient {
    getByCollaboratoreAsTrelloVm(showConcluded, concludedFilterDays, userIdentifier, showSpinner = true) {
        return CommonServices.defaultGet(baseUrl + 'api/Task/GetByCollaboratoreAsTrelloVm', { showConcluded, concludedFilterDays, userIdentifier }, showSpinner);
    }
    getAllAsTrelloVm(showConcluded, concludedFilterDays, officeIdentifier, showSpinner = true) {
        return CommonServices.defaultGet(baseUrl + 'api/Task/GetAllAsTrelloVm', { showConcluded, concludedFilterDays, officeIdentifier }, showSpinner);
    }
    exportExcel(fromDate, toDate, showSpinner = true) {
        return CommonServices.defaultGet(baseUrl + 'api/Task/ExportExcel', { fromDate, toDate }, showSpinner);
    }
    spostaTask(taskIdentifier, finalCustomerIdentifier, showSpinner = true) {
        return CommonServices.defaultGet(baseUrl + 'api/Task/SpostaTask', { taskIdentifier, finalCustomerIdentifier }, showSpinner);
    }
    setMetriQuadri(taskIdentifier, metriQuadri, showSpinner = true) {
        return CommonServices.defaultGet(baseUrl + 'api/Task/SetMetriQuadri', { taskIdentifier, metriQuadri }, showSpinner);
    }
    getAllAsTableVm(vm, showSpinner = true) {
        return CommonServices.defaultPost(baseUrl + 'api/Task/GetAllAsTableVm', vm, {}, showSpinner);
    }
    approveAndDeliver(taskIdentifier, showSpinner = true) {
        return CommonServices.defaultGet(baseUrl + 'api/Task/ApproveAndDeliver', { taskIdentifier }, showSpinner);
    }
    getById(taskIdentifier, showSpinner = true) {
        return CommonServices.defaultGet(baseUrl + 'api/Task/GetById', { taskIdentifier }, showSpinner);
    }
    updateStatus(taskIdentifier, newStatus, showSpinner = true) {
        return CommonServices.defaultGet(baseUrl + 'api/Task/UpdateStatus', { taskIdentifier, newStatus }, showSpinner);
    }
    addModificaRichiesta(vm, showSpinner = true) {
        return CommonServices.defaultPost(baseUrl + 'api/Task/AddModificaRichiesta', vm, {}, showSpinner);
    }
    getAllByUser(userIdentifier, showSpinner = true) {
        return CommonServices.defaultGet(baseUrl + 'api/Task/GetAllByUser', { userIdentifier }, showSpinner);
    }
    getInDates(userIdentifier, anno, mese, showSpinner = true) {
        return CommonServices.defaultGet(baseUrl + 'api/Task/GetInDates', { userIdentifier, anno, mese }, showSpinner);
    }
    createTaskFromCredits(task, showSpinner = true) {
        return CommonServices.defaultPost(baseUrl + 'api/Task/CreateTaskFromCredits', task, {}, showSpinner);
    }
    getCreditsConsumedByChild(childIdentifier, showSpinner = true) {
        return CommonServices.defaultGet(baseUrl + 'api/Task/GetCreditsConsumedByChild', { childIdentifier }, showSpinner);
    }
    save(task, showSpinner = true) {
        return CommonServices.defaultPost(baseUrl + 'api/Task/Save', task, {}, showSpinner);
    }
    assignTask(vm, showSpinner = true) {
        return CommonServices.defaultPost(baseUrl + 'api/Task/AssignTask', vm, {}, showSpinner);
    }
    getByCustomerIdentifierAsVm(customerIdentifier, lastDays, showSpinner = true) {
        return CommonServices.defaultGet(baseUrl + 'api/Task/GetByCustomerIdentifierAsVm', { customerIdentifier, lastDays }, showSpinner);
    }
    getByAssignedUserIdentifier(assignedUserIdentifier, showSpinner = true) {
        return CommonServices.defaultGet(baseUrl + 'api/Task/GetByAssignedUserIdentifier', { assignedUserIdentifier }, showSpinner);
    }
    deleteById(taskIdentifier, showSpinner = true) {
        return CommonServices.defaultGet(baseUrl + 'api/Task/DeleteById', { taskIdentifier }, showSpinner);
    }
    deleteAttachment(vm, showSpinner = true) {
        return CommonServices.defaultPost(baseUrl + 'api/Task/DeleteAttachment', vm, {}, showSpinner);
    }
    getTaskStat(mese, anno, showSpinner = true) {
        return CommonServices.defaultGet(baseUrl + 'api/Task/GetTaskStat', { mese, anno }, showSpinner);
    }
    newGestimTransaction(gestimRequest, showSpinner = true) {
        return CommonServices.defaultPost(baseUrl + 'newGestimTransaction', gestimRequest, {}, showSpinner);
    }
    notifyLavorazioneGestim(taskIdentifier, showSpinner = true) {
        return CommonServices.defaultGet(baseUrl + 'api/Task/notifyLavorazioneGestim', { taskIdentifier }, showSpinner);
    }
    sendPlanimetrieToGestim(taskIdentifier, showSpinner = true) {
        return CommonServices.defaultGet(baseUrl + 'api/Task/sendPlanimetrieToGestim', { taskIdentifier }, showSpinner);
    }
    reportTasks(vm, showSpinner = true) {
        return CommonServices.defaultPost(baseUrl + 'api/Task/ReportTasks', vm, {}, showSpinner);
    }
    getRiepilogoStandByTask(startDate, endDate, showSpinner = true) {
        return CommonServices.defaultGet(baseUrl + 'api/Task/GetRiepilogoStandByTask', { startDate, endDate }, showSpinner);
    }
    getRiepilogoErroriArchitetti(startDate, endDate, showSpinner = true) {
        return CommonServices.defaultGet(baseUrl + 'api/Task/GetRiepilogoErroriArchitetti', { startDate, endDate }, showSpinner);
    }
    zipTasks(vm, showSpinner = true) {
        return CommonServices.defaultPost(baseUrl + 'api/Task/ZipTasks', vm, {}, showSpinner);
    }
    zipTaskAttachments(taskIdentifier, requestAttachments, showSpinner = true) {
        return CommonServices.defaultGet(baseUrl + 'api/Task/ZipTaskAttachments', { taskIdentifier, requestAttachments }, showSpinner);
    }
}
export let TaskClient = new _TaskClient();
class _UserClient {
    getAll(showSpinner = true) {
        return CommonServices.defaultGet(baseUrl + 'api/User/GetAll', {}, showSpinner);
    }
    calcolaQualifiche(showSpinner = true) {
        return CommonServices.defaultGet(baseUrl + 'api/User/CalcolaQualifiche', {}, showSpinner);
    }
    exportExcel(showSpinner = true) {
        return CommonServices.defaultGet(baseUrl + 'api/User/ExportExcel', {}, showSpinner);
    }
    getAssuntiAsNameIdentifier(showSpinner = true) {
        return CommonServices.defaultGet(baseUrl + 'api/User/GetAssuntiAsNameIdentifier', {}, showSpinner);
    }
    getById(userIdentifier, showSpinner = true) {
        return CommonServices.defaultGet(baseUrl + 'api/User/GetById', { userIdentifier }, showSpinner);
    }
    delete(userIdentifier, showSpinner = true) {
        return CommonServices.defaultGet(baseUrl + 'api/User/Delete', { userIdentifier }, showSpinner);
    }
    save(user, showSpinner = true) {
        return CommonServices.defaultPost(baseUrl + 'api/User/Save', user, {}, showSpinner);
    }
    getByRoleAsNameIdentifier(role, showSpinner = true) {
        return CommonServices.defaultGet(baseUrl + 'api/User/GetByRoleAsNameIdentifier', { role }, showSpinner);
    }
    getByRoleAsNameIdentifierQualifica(role, showSpinner = true) {
        return CommonServices.defaultGet(baseUrl + 'api/User/GetByRoleAsNameIdentifierQualifica', { role }, showSpinner);
    }
    getAddettoRivendite(showSpinner = true) {
        return CommonServices.defaultGet(baseUrl + 'api/User/GetAddettoRivendite', {}, showSpinner);
    }
    saveUsersOrder(vm, showSpinner = true) {
        return CommonServices.defaultPost(baseUrl + 'api/User/SaveUsersOrder', vm, {}, showSpinner);
    }
    getSpesaCollaboratoriStat(mese, anno, showSpinner = true) {
        return CommonServices.defaultGet(baseUrl + 'api/User/GetSpesaCollaboratoriStat', { mese, anno }, showSpinner);
    }
}
export let UserClient = new _UserClient();
class SwaggerException extends Error {
    message;
    status;
    response;
    headers;
    result;
    constructor(message, status, response, headers, result) {
        super();
        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }
    isSwaggerException = true;
    static isSwaggerException(obj) {
        return obj.isSwaggerException === true;
    }
}
function throwException(message, status, response, headers, result) {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new SwaggerException(message, status, response, headers, null);
}
